import main from './main.js'
import apiMenu from '@/api/Menu.js'
import apiOutlet from '@/api/Outlet.js'
import apiCustomer from '@/api/Customer.js'
import apiCart from '@/api/Cart.js'
import apiOrder from '@/api/Order.js'
import apiTenant from '@/api/Tenant.js'
import apiPayment from '@/api/Payment.js'
import apiCampaign from '@/api/Campaign.js'
import apiCoupon from '@/api/Coupon.js'
import apiSlotGame from '@/api/SlotGame.js'
import apiBanners from '@/api/Banners.js'
import apiContent from '@/api/Content.js'
import apiTopic from '@/api/Topic.js'
import _ from 'lodash'

var axios = require('axios')
axios.options = {
  flag: false, // false : not show ajax loader
  notify: false // false : not show notify error
}
axios.defaults.baseURL = process.env.host
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.interceptors.request.use(
  success => {
    if (axios.options.flag) {
      main.callEventBus(main.$const.EVENT_BUS.LOADING, true)
    }

    return success
  },
  error => {
    if (axios.options.flag) {
      main.callEventBus(main.$const.EVENT_BUS.LOADING, false)
    }

    return Promise.reject(error)
  }
)
axios.interceptors.response.use(
  success => {
    if (axios.options.flag) {
      main.callEventBus(main.$const.EVENT_BUS.LOADING, false)
    }

    axios.options.flag = true
    axios.options.notify = true

    return success
  },
  error => {
    if (axios.options.flag) {
      main.callEventBus(main.$const.EVENT_BUS.LOADING, false)
    }

    axios.options.flag = true
    const code = error.response.data.error.code && error.response.data.error.code.toString();
    if (code === main.$const.CUSTOMER_CODE.INVALID) {
      main.$auth.logout()
    }
    if (main.$const.CUSTOMER_INVALID.includes(code)) {
      main.$router.replace({name: 'login'})
    }

    // convert message
    let message = main.getMessageFromGms(error.response.data)
    let _code = error.response.data.error.code
    // PAYMENT COUPON ERROR
    if (main.$const.PAYMENT_COUPON_ERROR.indexOf(_code) >= 0) {
      let _error = error.response.data.error
      if (
        _error.hasOwnProperty('data') && !main.empty(_error.data)
      ) {
        let _paymentList = _error.data || []
        let paymentName = []
        if (!main.empty(_paymentList)) {
          for (let p of _paymentList) {
            paymentName = paymentName.concat(p.payment_list.split(', '))
          }
          message = main.$t('coupon.payment_custom', {name: _.uniq(paymentName).join(', ')})
          error.response.data.error.message = message
        }
      }
    }

    if ([main.$const.CART_CODE.SELLINGTIME,
        main.$const.CART_CODE.INVALIDHUTDAY,
        main.$const.CART_CODE.INVALIDLUNCHTIME,
        main.$const.CART_CODE.NOTFOUND,
        main.$const.LOCALIZATION_CODE.NOTOPEN,
        main.$const.LOCALIZATION_CODE.UNAVALIABLE,
        main.$const.LOCALIZATION_CODE.STORECLOSE,
        main.$const.LOCALIZATION_CODE.CLOSESTORE,
        main.$const.CART_CODE.CART_EMPTY_ADD_ON
      ].indexOf(error.response.data.error.code) < 0) {
      if (axios.options.notify && main.$const.MESSAGES_CODE.STOP_DELIVERY_TOTAL.indexOf(error.response.data.error.code) < 0) {
        main.$notify({
          type: 'error',
          title: message
        })
      }
    }
    axios.options.notify = true

    return Promise.reject(error)
  }
)

axios.apiMenu = apiMenu
axios.apiOutlet = apiOutlet
axios.apiCustomer = apiCustomer
axios.apiCart = apiCart
axios.apiOrder = apiOrder
axios.apiTenant = apiTenant
axios.apiOrder = apiOrder
axios.apiPayment = apiPayment
axios.apiCampaign = apiCampaign
axios.apiCoupon = apiCoupon
axios.apiSlotGame = apiSlotGame
axios.apiBanners = apiBanners
axios.apiContent = apiContent
axios.apiTopic = apiTopic

export default axios



// WEBPACK FOOTER //
// ./src/axios.js